import { useCallback } from "react";
import { useNavigate } from "react-router";

/**
 * Back navigation that still works when a page was opened directly.
 *
 * `navigate(-1)` on a shared or pasted link has no in-app history to return
 * to, so it either leaves the site or does nothing. React Router stamps an
 * `idx` onto history state; 0 means this is the first entry, so go to the
 * fallback instead.
 */
export default function useGoBack(
  // The Launchpad home lives at /test until real routing lands.
  fallback: string = "/test"
): () => void {
  const navigate = useNavigate();

  return useCallback(() => {
    const index = (window.history.state as { idx?: unknown } | null)?.idx;

    if (typeof index === "number" && index > 0) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  }, [navigate, fallback]);
}
